import { render, staticRenderFns } from "./abs_summaries.vue?vue&type=template&id=3d226684&scoped=true&"
import script from "./abs_summaries.vue?vue&type=script&lang=js&"
export * from "./abs_summaries.vue?vue&type=script&lang=js&"
import style0 from "./abs_summaries.vue?vue&type=style&index=0&id=3d226684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d226684",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d226684')) {
      api.createRecord('3d226684', component.options)
    } else {
      api.reload('3d226684', component.options)
    }
    module.hot.accept("./abs_summaries.vue?vue&type=template&id=3d226684&scoped=true&", function () {
      api.rerender('3d226684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade_data/abs_graphs/abs_summaries.vue"
export default component.exports